import { useMemo } from 'react';
import { useShowContext } from 'framework/show';
import { PublishAssetShowType } from '../types';
import { DIFF_TAGS, DiffItem } from 'framework/DiffViewer';

export const PUBLISH_ASSET_MODES = {
  SOURCE: 'SOURCE',
  RENDERED: 'RENDERED',
} as const;

export type ViewMode = keyof typeof PUBLISH_ASSET_MODES;

const usePublishAssetData = () => {
  const { data: contextData } = useShowContext<PublishAssetShowType>();
  const data = contextData.getData();

  const {
    documentPath,
    previewRenderPath,
    sourceDiff,
    renderedDiff,
    loadErrors,
    metadata: { version, uploadedBy },
  } = data;

  const isFirstPublish = version === 1;

  const percentChanges = useMemo(() => {
    if (!sourceDiff?.differences?.length) return 0;
    const changed = sourceDiff.differences.filter((i: DiffItem) => i.tag !== DIFF_TAGS.EQUAL).length;
    return (changed / sourceDiff.differences.length) * 100;
  }, [sourceDiff]);

  const canShowSource = !!documentPath;

  const canShowRendered = !!previewRenderPath && !loadErrors.previewNew;

  const canToggleView = canShowSource && canShowRendered;

  const canShowSourceDiff = !!sourceDiff?.differences?.length && !loadErrors.sourceDiff;

  const canShowRenderedDiff = !!renderedDiff?.differences?.length && !loadErrors.renderedDiff;

  return {
    // data
    documentPath,
    previewRenderPath,
    sourceDiff,
    renderedDiff,
    uploadedBy,
    isFirstPublish,
    percentChanges,

    // flags
    canShowSource,
    canShowRendered,
    canToggleView,
    canShowSourceDiff,
    canShowRenderedDiff,
  };
};

export default usePublishAssetData;
